module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kbx-text-editor-toolbar"
  }, [_c('span', {
    staticClass: "ql-formats"
  }, [_c('editor-button', {
    attrs: {
      "type": "bold"
    }
  }), _vm._v(" "), _c('editor-button', {
    attrs: {
      "type": "italic"
    }
  }), _vm._v(" "), _c('editor-button', {
    attrs: {
      "type": "underline"
    }
  }), _vm._v(" "), _c('editor-button', {
    attrs: {
      "type": "strike"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('editor-color', {
    attrs: {
      "type": "color"
    }
  }), _vm._v(" "), _c('editor-color', {
    attrs: {
      "type": "background"
    }
  })], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-133d8184!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/TextEditor/toolbar/Main.vue
 ** module id = 768
 ** module chunks = 1
 **/